import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Accordion from './Accordion';
import './NavTab.scss';

// keepMounted: render every item's content and only show the active one — for sections that
// report their count on mount (onCountChange), so the menu counts are right before a click
export default function NavTab({ menuItems = [], withTabs = true, activeTab: controlledTab, onTabChange, className, keepMounted = false }) {
    const [internalTab, setInternalTab] = useState(menuItems[0]?.id);
    const activeTab = controlledTab ?? internalTab;
    const setActiveTab = (id) => { setInternalTab(id); onTabChange?.(id); };
    const activeItem = menuItems.find(item => item.id === activeTab);

    if (!withTabs) {
        return (
            <div className="navtab-accordion">
                {menuItems.map(item => (
                    <Accordion key={item.id} id={item.id} title={item.label} icon={item.icon} count={item.count} defaultOpen={item.defaultOpen} flush={item.flush}>
                        {item.component}
                    </Accordion>
                ))}
            </div>
        );
    }

    return (
        <div className={`navtab ${className || ''}`.trim()}>
            <div className="navtab-sidebar">
                <nav className="navtab-nav">
                    {menuItems.map(item => (
                        <button
                            key={item.id}
                            type="button"
                            className={`navtab-link ${activeTab === item.id ? 'active' : ''}`}
                            onClick={() => {
                                item.onClick?.();
                                if (!item.interceptClick) setActiveTab(item.id);
                            }}
                        >
                            {item.icon && (
                                <span className="navtab-icon">
                                    <FontAwesomeIcon icon={item.icon} />
                                </span>
                            )}
                            <span className="navtab-text">
                                <span className="navtab-label">{item.label}</span>
                                {item.description && (
                                    <span className="navtab-description">{item.description}</span>
                                )}
                            </span>
                            {!!item.count && (
                                <span className="navtab-count">{item.count}</span>
                            )}
                        </button>
                    ))}
                </nav>
            </div>

            <div className="navtab-content">
                {keepMounted
                    ? menuItems.map(item => (
                        <div key={item.id} className={`navtab-panel navtab-panel--${item.id}`} hidden={item.id !== activeTab}>
                            {item.component}
                        </div>
                    ))
                    : activeItem?.component}
            </div>
        </div>
    );
}
